import React from 'react';
import { NavLink } from 'react-router-dom';
import ENUMS from '../../enums';
import { enumHelper } from '../../utils';

const convertCafeStatusToCssClass = status => {
  switch (status) {
    case ENUMS.CAFE_STATUS.values.REQUESTED:
      return 'text-warning';
    case ENUMS.CAFE_STATUS.values.CONFIRMED:
      return 'text-success';
    case ENUMS.CAFE_STATUS.values.PENDING:
      return 'text-info';
    default:
      return 'text-muted';
  }
};

export const cafeList = [
  {
    title: 'ردیف',
    isRowNumber: true
  },
  {
    title: 'نام',
    dataIndex: 'name',
    name: 'name',
    isSortable: true
  },
  {
    title: 'مدیر کافه',
    dataIndex: 'ownerFullName',
    name: 'cafeManagerName',
    isSortable: true
  },
  {
    title: 'نوع کافه',
    dataIndex: 'cafeType',
    name: 'cafeType',
    isSortable: false
  },
  {
    title: 'آدرس',
    dataIndex: 'address',
    name: 'address',
    isSortable: true
  },
  {
    title: 'زمان ثبت',
    dataIndex: 'createdAt',
    name: 'createdAt',
    isSortable: true
  },
  {
    title: 'امتیاز',
    dataIndex: 'score',
    name: 'score',
    isSortable: true
  },
  {
    title: 'تخفیف',
    dataIndex: 'hasDiscount',
    render: value =>
      value ? (
        <i className={'fal fa-vote-yea mx-1 text-success'} />
      ) : (
        <i className={'fal fa-vote-nay mx-1 text-danger'} />
      )
  },
  {
    title: 'رویداد',
    dataIndex: 'hasEvent',
    render: value =>
      value ? (
        <i className={'fal fa-vote-yea mx-1 text-success'} />
      ) : (
        <i className={'fal fa-vote-nay mx-1 text-danger'} />
      )
  },
  {
    title: 'برتر',
    dataIndex: 'isBest',
    render: value =>
      value ? (
        <i className={'fal fa-vote-yea mx-1 text-success'} />
      ) : (
        <i className={'fal fa-vote-nay mx-1 text-danger'} />
      )
  },
  {
    title: 'وضعیت کافه',
    dataIndex: 'status',
    render: status => (
      <span className={convertCafeStatusToCssClass(status)}>
        {enumHelper.convertEnumValueToTitle(ENUMS.CAFE_STATUS.list, status)}
      </span>
    )
  },
  {
    title: 'عملیات',
    action: (cafe, action) => (
      <>
        {(cafe.status === ENUMS.CAFE_STATUS.values.DISABLED ||
          cafe.status === ENUMS.CAFE_STATUS.values.PENDING) && (
          <a
            onClick={e => {
              e.preventDefault();
              action.activateCafe(cafe.id);
            }}
            href="#"
            className="text-success"
          >
            {locales('labels.activate.cafe')}
          </a>
        )}
        {cafe.status === ENUMS.CAFE_STATUS.values.CONFIRMED && (
          <a
            onClick={e => {
              e.preventDefault();
              action.disableCafe(cafe.id);
            }}
            href="#"
            className="text-danger"
          >
            {locales('labels.disable.cafe')}
          </a>
        )}
        <NavLink
          to={{
            pathname: '/cafes/edit',
            cafeId: cafe.id
          }}
        >
          <i className="font-xlarge mx-1 text-success far fa-pen-square mx-2" />
        </NavLink>
        <NavLink
          to={{
            cafeName: cafe.name,
            pathname: '/cafes/users',
            cafeId: cafe.id
          }}
        >
          <i className="far fa-users font-xlarge mx-1 text-info" />
        </NavLink>
      </>
    )
  }
];
